export const SearchIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none">
      <g fill="#000">
        <g>
          <g>
            <g>
              <path
                d="M8 .25c4.28 0 7.75 3.47 7.75 7.75 0 1.87-.662 3.585-1.765 4.924l5.545 5.546c.293.293.293.767 0 1.06-.266.267-.683.29-.976.073l-.084-.073-5.546-5.545C11.585 15.088 9.87 15.75 8 15.75 3.72 15.75.25 12.28.25 8 .25 3.72 3.72.25 8 .25zm0 1.5C4.548 1.75 1.75 4.548 1.75 8S4.548 14.25 8 14.25s6.25-2.798 6.25-6.25S11.452 1.75 8 1.75z"
                transform="translate(-960 -40) translate(800 32) translate(160 8) translate(2 2)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const UserIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30">
    <g fill="none">
      <g fill="#FFF">
        <g>
          <g>
            <g>
              <path
                d="M7.288 16.026c1.804-.16 3.62-.16 5.424 0l.576.049c.789.078 1.571.2 2.341.364 1.963.404 3.389 1.121 4.02 2.452.468.99.468 2.14 0 3.13-.633 1.333-2.077 2.057-4.005 2.437l-.584.121c-.781.15-1.568.253-2.35.306-1.468.125-2.943.148-4.365.07h-.201l-.154-.003-.18-.007c-.22-.011-.42-.034-.504-.059-.99-.067-1.973-.21-2.916-.423l-.32-.067C2.285 24 .962 23.284.35 22.02.12 21.53 0 20.992 0 20.453c-.002-.542.119-1.078.36-1.578.636-1.28 2.133-2.05 4.004-2.435.969-.208 1.951-.346 2.924-.414zm5.266 1.803c-1.7-.15-3.409-.15-5.125.001-.904.063-1.803.19-2.696.381-1.384.285-2.442.83-2.756 1.461-.116.242-.176.507-.175.78 0 .273.06.544.173.784.324.67 1.322 1.17 2.785 1.456l.44.093c.738.147 1.498.248 2.343.311.107.022.222.035.358.042l.492.008c1.388.075 2.78.054 4.179-.065.902-.062 1.798-.192 2.702-.394l.282-.06c1.284-.29 2.173-.767 2.465-1.384.236-.498.236-1.077 0-1.575-.313-.66-1.302-1.158-2.76-1.458-.887-.19-1.786-.316-2.69-.38zM10.005 0c3.668 0 6.641 2.986 6.641 6.669 0 3.683-2.973 6.669-6.64 6.669-3.668 0-6.641-2.986-6.641-6.669C3.365 2.986 6.338 0 10.005 0zm0 1.81c-2.672 0-4.838 2.175-4.838 4.859s2.166 4.86 4.838 4.86c2.673 0 4.84-2.176 4.84-4.86s-2.167-4.86-4.84-4.86z"
                transform="translate(-1373 -37) translate(1040) translate(328 32) translate(5 5) translate(5 2.5)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const AddIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="#FFF">
    <path
      d="M13.467.55c.632 0 1.155.47 1.238 1.08l.012.17-.001 10.416h10.417c.69 0 1.25.56 1.25 1.25 0 .633-.47 1.156-1.08 1.24l-.17.01H14.716v10.417c0 .69-.559 1.25-1.25 1.25-.632 0-1.155-.47-1.238-1.08l-.011-.17-.001-10.417H1.8c-.69 0-1.25-.559-1.25-1.25 0-.632.47-1.155 1.08-1.238l.17-.011 10.416-.001V1.8c0-.69.56-1.25 1.25-1.25z"
      transform="translate(-1220 -476) translate(1040) translate(180 476) translate(6.533 6.533)"
    />
  </svg>
);

export const FolderIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32">
    <path
      fill="#0F0F10"
      d="M25.206 20.463H1.42c-.784 0-1.42-.635-1.42-1.42v-17.6C0 .657.636.022 1.42.022h6.715c.513 0 .986.276 1.238.723l.783 1.393c.251.447.724.723 1.237.723h13.813c.785 0 1.42.636 1.42 1.42v14.761c0 .785-.635 1.42-1.42 1.42z"
      transform="translate(-62 -244) translate(48 232) translate(14 12) translate(2.667 5.333)"
    />
    <path
      fill="#5C5C5C"
      d="M1.42 20.463h23.786c.785 0 1.42-.635 1.42-1.42V4.283c0-.785-.635-1.42-1.42-1.42H14.941c-.513 0-.986.276-1.237.723L12.92 4.98c-.252.447-.725.724-1.238.724H1.42c-.784 0-1.42.635-1.42 1.42v11.92c0 .785.636 1.42 1.42 1.42z"
      transform="translate(-62 -244) translate(48 232) translate(14 12) translate(2.667 5.333)"
    />
    <path
      fill="#1A1A1A"
      d="M25.789 2.99c.08.178.127.374.127.583v14.76c0 .784-.635 1.42-1.42 1.42H.71c-.208 0-.404-.047-.582-.127.222.493.716.837 1.292.837h23.786c.785 0 1.42-.635 1.42-1.42V4.283c0-.577-.344-1.07-.837-1.293z"
      transform="translate(-62 -244) translate(48 232) translate(14 12) translate(2.667 5.333)"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="#FFF">
    <path
      d="M8.75-.938c.475 0 .867.353.929.81L9.687 0v7.813H17.5c.518 0 .938.42.938.937 0 .475-.353.867-.81.929l-.128.008H9.687V17.5c0 .518-.42.938-.937.938-.475 0-.867-.353-.929-.81l-.008-.128V9.687H0c-.518 0-.938-.42-.938-.937 0-.475.353-.867.81-.929L0 7.813h7.813V0c0-.518.42-.938.937-.938z"
      transform="translate(-1373 -37) translate(1040) translate(328 32) translate(5 5) rotate(45 4.33 19.42)"
    />
  </svg>
);

export const GridView = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="#000">
    <path
      d="M11.75 16.25c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2v-6c0-1.105.895-2 2-2h6zm12.5 0c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2v-6c0-1.105.895-2 2-2h6zm-12.5-12.5c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2v-6c0-1.105.895-2 2-2h6zm12.5 0c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2v-6c0-1.105.895-2 2-2h6z"
      transform="translate(-53 -117) translate(48 112) translate(5 5)"
    />
  </svg>
);

export const GalleryView = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="#000">
    <path
      d="M6.5 22.5c.552 0 1 .448 1 1v1.75c0 .552-.448 1-1 1H4.75c-.552 0-1-.448-1-1V23.5c0-.552.448-1 1-1H6.5zm6.25 0c.552 0 1 .448 1 1v1.75c0 .552-.448 1-1 1H11c-.552 0-1-.448-1-1V23.5c0-.552.448-1 1-1h1.75zm6.25 0c.552 0 1 .448 1 1v1.75c0 .552-.448 1-1 1h-1.75c-.552 0-1-.448-1-1V23.5c0-.552.448-1 1-1H19zm6.25 0c.552 0 1 .448 1 1v1.75c0 .552-.448 1-1 1H23.5c-.552 0-1-.448-1-1V23.5c0-.552.448-1 1-1h1.75zm-1-18.75c1.105 0 2 .895 2 2V18c0 1.105-.895 2-2 2H5.75c-1.105 0-2-.895-2-2V5.75c0-1.105.895-2 2-2h18.5z"
      transform="translate(-101 -117) translate(96 112) translate(5 5)"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF">
    <path
      d="M15 18.25c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L15 19.75H1c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L1 18.25h14zm-7-18c.38 0 .693.282.743.648L8.75 1v11.189l2.72-2.72c.266-.266.683-.29.976-.072l.084.073c.267.266.29.683.073.976l-.073.084-4 4c-.034.035-.071.065-.11.092l-.095.054-.086.035-.103.027-.085.01H7.95l-.12-.018-.068-.019-.06-.023-.07-.035-.077-.05c-.033-.025-.06-.048-.084-.073l-4-4c-.293-.293-.293-.767 0-1.06.266-.267.683-.29.976-.073l.084.073 2.72 2.719V1c0-.414.336-.75.75-.75z"
      transform="translate(-1137 -948) translate(1040) translate(32 936) translate(65 12) translate(4 2)"
    />
  </svg>
);

export const TripleDots = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="#FFF">
    <path
      d="M6 15c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm12 0c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm12 0c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
      transform="translate(-1366 -942) translate(1040) translate(320 936) translate(6 6)"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#FF3B30">
    <path
      d="M12 .25c.918 0 1.671.707 1.744 1.606L13.75 2v2.25H17c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L17 5.75h-1.25V18c0 .918-.707 1.671-1.606 1.744L14 19.75H4c-.966 0-1.75-.784-1.75-1.75V5.75H1C.586 5.75.25 5.414.25 5c0-.38.282-.693.648-.743L1 4.25h3.25V2c0-.918.707-1.671 1.606-1.744L6 .25h6zm2.25 5.5H3.75V18c0 .118.082.217.193.243L4 18.25h10c.138 0 .25-.112.25-.25V5.75zM7 8.25c.38 0 .693.282.743.648L7.75 9v6c0 .414-.336.75-.75.75-.38 0-.693-.282-.743-.648L6.25 15V9c0-.414.336-.75.75-.75zm4 0c.38 0 .693.282.743.648L11.75 9v6c0 .414-.336.75-.75.75-.38 0-.693-.282-.743-.648L10.25 15V9c0-.414.336-.75.75-.75zm1-6.5H6c-.118 0-.217.082-.243.193L5.75 2v2.25h6.5V2c0-.118-.082-.217-.193-.243L12 1.75z"
      transform="translate(-1216 -784) translate(1040) translate(152 760) translate(0 12) translate(24 12) translate(3 2)"
    />
  </svg>
);

export const EditIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff">
    <path
      d="M13.265 4.493c.982-1.252 2.628-1.294 3.92-.28l1.39 1.09c1.294 1.014 1.646 2.62.664 3.873l-8.288 10.575c-.418.533-1.055.848-1.731.856l-3.197.04c-.353.005-.66-.236-.74-.58l-.724-3.114c-.154-.658 0-1.35.417-1.885zm-.836 3.496l-6.272 8.003c-.138.177-.188.405-.138.62l.587 2.527 2.596-.032c.185-.002.36-.074.493-.2l.075-.081 6.273-8.004-3.614-2.833zm3.831-2.596c-.685-.537-1.387-.52-1.815.025l-1.09 1.39 3.613 2.833 1.09-1.39c.402-.512.295-1.145-.286-1.666l-.122-.102z"
      transform="translate(-1216 -832) translate(1040) translate(152 760) translate(0 60) translate(24 12)"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
    <path
      d="M7.746 19.759c-.298-.292-.325-.75-.081-1.072l.08-.092L14.474 12 7.746 5.405c-.298-.292-.325-.75-.081-1.072l.08-.092c.299-.292.765-.319 1.094-.08l.094.08 7.321 7.177c.298.292.325.75.081 1.072l-.08.092-7.322 7.177c-.328.321-.86.321-1.187 0z"
      transform="translate(-128 -120) translate(128 120)"
    />
  </svg>
);

export const DownIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF">
    <path
      d="M4.241 7.746c.292-.298.75-.325 1.072-.081l.092.08L12 14.474l6.595-6.727c.292-.298.75-.325 1.072-.081l.092.08c.292.299.319.765.08 1.094l-.08.094-7.177 7.321c-.292.298-.75.325-1.072.081l-.092-.08-7.177-7.322c-.321-.328-.321-.86 0-1.187z"
      transform="translate(-336 -318) translate(48 302) translate(288 16)"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg height="384pt" viewBox="0 -53 384 384" width="384pt">
    <path d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
    <path d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
    <path d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
  </svg>
);

export const LeftArrow = () => (
  <svg width="12" height="20" viewBox="0 0 12 20" fill="#FFF">
    <path
      d="M20.318 5.301c.372.366.406.937.101 1.34l-.101.115L11.908 15l8.41 8.244c.372.365.406.937.101 1.34l-.101.115c-.373.365-.956.398-1.367.1l-.118-.1-9.15-8.972c-.373-.365-.407-.936-.102-1.34l.101-.114L18.833 5.3c.41-.401 1.075-.401 1.485 0z"
      transform="translate(-918 -122) translate(904 112) translate(5 5)"
    />
  </svg>
);

export const RightArrow = () => (
  <svg width="12" height="20" viewBox="0 0 12 20" fill="#FFF">
    <path
      d="M9.682 24.699c-.372-.366-.406-.937-.101-1.34l.101-.115L18.092 15l-8.41-8.244c-.372-.365-.406-.937-.101-1.34l.101-.115c.373-.365.956-.398 1.367-.1l.118.1 9.15 8.972c.373.365.407.936.102 1.34l-.101.114-9.151 8.972c-.41.401-1.075.401-1.485 0z"
      transform="translate(-966 -122) translate(952 112) translate(5 5)"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="#FFF">
    <path
      d="M38.683 1.35c.912-.911 2.389-.911 3.3 0 .841.841.906 2.165.194 3.08l-.194.22-24 24c-.84.841-2.164.906-3.08.194l-.22-.194L1.35 15.317c-.911-.912-.911-2.389 0-3.3.841-.841 2.165-.906 3.08-.194l.22.194 11.683 11.682L38.683 1.35z"
      transform="translate(-132 -430) translate(48 382) translate(84 48) translate(6.333 13.333)"
    />
  </svg>
);

export const UplpadFileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
    <path
      d="M20.047 10.672h-2.813V4.344C17.234 3.05 16.183 2 14.891 2H4.344C3.05 2 2 3.051 2 4.344V14.89c0 1.292 1.051 2.343 2.344 2.343h6.328v2.813c0 1.077.876 1.953 1.953 1.953h7.422C21.124 22 22 21.124 22 20.047v-7.422c0-1.077-.876-1.953-1.953-1.953zm-9.375 1.953v3.047H4.344c-.431 0-.782-.35-.782-.781V4.344c0-.431.351-.782.782-.782H14.89c.43 0 .78.351.78.782v6.328h-3.046c-1.077 0-1.953.876-1.953 1.953zm9.765 7.422c0 .215-.175.39-.39.39h-7.422c-.215 0-.39-.175-.39-.39v-7.422c0-.215.175-.39.39-.39h7.422c.215 0 .39.175.39.39v7.422z"
      transform="translate(-708 -496) translate(464 384) translate(244 112)"
    />
  </svg>
);

export const EyeIcon = () => (
  <svg height="25" viewBox="0 0 40.991 27.515">
    <path d="M.281,14.881A1.688,1.688,0,0,1,0,13.757a1.688,1.688,0,0,1,.281-1.123A22.824,22.824,0,0,1,20.5,0,22.505,22.505,0,0,1,40.711,12.634a1.688,1.688,0,0,1,.281,1.123c0,.281-.281.842-.281,1.123A22.824,22.824,0,0,1,20.5,27.515,22.824,22.824,0,0,1,.281,14.881Zm9.827-1.4A10.388,10.388,0,1,0,20.5,3.089,10.191,10.191,0,0,0,10.108,13.477Zm3.959-.219a6.5,6.5,0,1,1,6.5,6.5A6.5,6.5,0,0,1,14.067,13.258Z" />
  </svg>
);

export const CloseEyeIcon = () => (
  <svg height="25" viewBox="0 0 41.315 38.498">
    <path d="M28.557,31.988A22.085,22.085,0,0,1,8.921,29.912,23.842,23.842,0,0,1,.6,20.756a1.7,1.7,0,0,1-.281-1.13A1.7,1.7,0,0,1,.6,18.5a24.193,24.193,0,0,1,4.431-6.048,23.363,23.363,0,0,1,2.289-2L0,3.032,2.947,0,38.211,35.264,34.978,38.5ZM11.42,14.792a10.693,10.693,0,0,0-.988,4.555A10.361,10.361,0,0,0,20.82,29.735a10.415,10.415,0,0,0,4.506-1.023l-3.162-3.206a6.51,6.51,0,0,1-7.634-7.741L11.478,14.67ZM36.168,27.22l-5.28-5.279a10.576,10.576,0,0,0,.32-2.594A10.369,10.369,0,0,0,20.82,8.958a11.042,11.042,0,0,0-2.607.307l-2.739-2.74a22.14,22.14,0,0,1,5.346-.653A22.537,22.537,0,0,1,41.035,18.5a1.7,1.7,0,0,1,.28,1.121,2.159,2.159,0,0,1-.14.565,2.172,2.172,0,0,0-.139.565,24.2,24.2,0,0,1-4.866,6.464h0ZM27.351,18.4l-5.738-5.737A6.5,6.5,0,0,1,27.352,18.4v0Z" />
  </svg>
);

export const NoData = () => (
  <svg height="512pt" viewBox="0 -12 512.00032 512" width="512pt"><path d="m455.074219 172.613281 53.996093-53.996093c2.226563-2.222657 3.273438-5.367188 2.828126-8.480469-.441407-3.113281-2.328126-5.839844-5.085938-7.355469l-64.914062-35.644531c-4.839844-2.65625-10.917969-.886719-13.578126 3.953125-2.65625 4.84375-.890624 10.921875 3.953126 13.578125l53.234374 29.230469-46.339843 46.335937-166.667969-91.519531 46.335938-46.335938 46.839843 25.722656c4.839844 2.65625 10.921875.890626 13.578125-3.953124 2.660156-4.839844.890625-10.921876-3.953125-13.578126l-53.417969-29.335937c-3.898437-2.140625-8.742187-1.449219-11.882812 1.695313l-54 54-54-54c-3.144531-3.144532-7.988281-3.832032-11.882812-1.695313l-184.929688 101.546875c-2.757812 1.515625-4.644531 4.238281-5.085938 7.355469-.445312 3.113281.601563 6.257812 2.828126 8.480469l53.996093 53.996093-53.996093 53.992188c-2.226563 2.226562-3.273438 5.367187-2.828126 8.484375.441407 3.113281 2.328126 5.839844 5.085938 7.351562l55.882812 30.6875v102.570313c0 3.652343 1.988282 7.011719 5.1875 8.769531l184.929688 101.542969c1.5.824219 3.15625 1.234375 4.8125 1.234375s3.3125-.410156 4.8125-1.234375l184.929688-101.542969c3.199218-1.757812 5.1875-5.117188 5.1875-8.769531v-102.570313l55.882812-30.683594c2.757812-1.515624 4.644531-4.242187 5.085938-7.355468.445312-3.113282-.601563-6.257813-2.828126-8.480469zm-199.074219 90.132813-164.152344-90.136719 164.152344-90.140625 164.152344 90.140625zm-62.832031-240.367188 46.332031 46.335938-166.667969 91.519531-46.335937-46.335937zm-120.328125 162.609375 166.667968 91.519531-46.339843 46.339844-166.671875-91.519531zm358.089844 184.796875-164.929688 90.5625v-102.222656c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v102.222656l-164.929688-90.5625v-85.671875l109.046876 59.878907c1.511718.828124 3.167968 1.234374 4.808593 1.234374 2.589844 0 5.152344-1.007812 7.074219-2.929687l54-54 54 54c1.921875 1.925781 4.484375 2.929687 7.074219 2.929687 1.640625 0 3.296875-.40625 4.808593-1.234374l109.046876-59.878907zm-112.09375-46.9375-46.339844-46.34375 166.667968-91.515625 46.34375 46.335938zm0 0"/><path d="m404.800781 68.175781c2.628907 0 5.199219-1.070312 7.070313-2.933593 1.859375-1.859376 2.929687-4.4375 2.929687-7.066407 0-2.632812-1.070312-5.210937-2.929687-7.070312-1.859375-1.863281-4.441406-2.929688-7.070313-2.929688-2.640625 0-5.210937 1.066407-7.070312 2.929688-1.871094 1.859375-2.929688 4.4375-2.929688 7.070312 0 2.628907 1.058594 5.207031 2.929688 7.066407 1.859375 1.863281 4.441406 2.933593 7.070312 2.933593zm0 0"/><path d="m256 314.925781c-2.628906 0-5.210938 1.066407-7.070312 2.929688-1.859376 1.867187-2.929688 4.4375-2.929688 7.070312 0 2.636719 1.070312 5.207031 2.929688 7.078125 1.859374 1.859375 4.441406 2.921875 7.070312 2.921875s5.210938-1.0625 7.070312-2.921875c1.859376-1.871094 2.929688-4.441406 2.929688-7.078125 0-2.632812-1.070312-5.203125-2.929688-7.070312-1.859374-1.863281-4.441406-2.929688-7.070312-2.929688zm0 0"/></svg>
);
